module.exports = __webpack_public_path__ + "static/media/ni.90122ad5.jpeg";